// src/components/ScrollToTopOnRoute/ScrollToTopOnRoute.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopOnRoute() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // tai "auto"
    });
  }, [pathname]);

  return null;
}
